import * as React from "react";

/**
 * T-212 (Teil B) — „[Entwurf]" an einer Mail der Liste, wie in Outlook: Zu
 * dieser Mail liegt ein Antwort-Entwurf. Ein Klick setzt ihn fort und öffnet
 * die Mail selbst NICHT (die Zeile ist ebenfalls klickbar).
 */
export const EntwurfMarker: React.FC<{ className?: string; onFortsetzen: () => void }> = ({
    className,
    onFortsetzen,
}) => (
    <button
        type="button"
        className={className}
        title="Zu dieser Mail gibt es einen Antwort-Entwurf – klicken zum Fortsetzen"
        aria-label="Antwort-Entwurf fortsetzen"
        onClick={(e) => {
            e.stopPropagation();
            onFortsetzen();
        }}
    >
        [Entwurf]
    </button>
);
